// Ambiente e versão do build (injetados por REACT_APP_*).
export const APP_ENV = process.env.REACT_APP_ENV || "DEV";
export const APP_VERSION = process.env.REACT_APP_VERSION || "dev";

// Cor do cabeçalho por ambiente: verde escuro em HOMOLOGAÇÃO (diferencia do
// vermelho da marca em produção). PRD/DEV mantêm o vermelho (primary.light.base).
export const HEADER_BG = APP_ENV === "HML" ? "#14532d" : "primary.light.base";
